export const RENDER_TYPE = "table-v2";
